import PropTypes from 'prop-types'
import React from 'react'

import Summary from '@/checkout-instore-legacy/components/Commons/Summary'
import { isDesktopBreakpoint } from '@/checkout-instore-legacy/utils/mediaQuery'

class Footer extends React.Component {
  handleSummaryAnimation = () => {
    if (!isDesktopBreakpoint()) {
      this.props.onHandleToggleSummary()
    }
  }

  render() {
    const { showFullSummary, children, rightElement } = this.props

    if (!children) return null

    return (
      <div
        id="Footer"
        className={`flex flex-column
                  ${
                    showFullSummary
                      ? 'flex-auto h-100'
                      : 'flex-none flex-auto-l'
                  }
        `}
      >
        <Summary
          showFullSummary={showFullSummary}
          onHandleToggleSummary={this.handleSummaryAnimation}
          rightElement={rightElement}
        >
          {children}
        </Summary>
      </div>
    )
  }
}

Footer.propTypes = {
  showFullSummary: PropTypes.bool,
  onHandleToggleSummary: PropTypes.func,
  rightElement: PropTypes.node,
  children: PropTypes.node,
}

export default Footer
